// extracted by mini-css-extract-plugin
export default {"errorMessage":"ActionMenu_errorMessage__s+NdW","copyErrorText":"ActionMenu_copyErrorText__HAXgH","actionMenuLink":"ActionMenu_actionMenuLink__iUYeB"};